module.exports = __webpack_public_path__ + "img/banner.399fee6c.jpg";